<ng-container>
  <input
    name="file"
    #fileInput
    class="file-selector__input"
    type="file"
    [attr.accept]="formattedFileExtensions"
    [multiple]="multiple"
    (change)="filesChanged($event)"
  />
  <button
    type="button"
    ftrButton
    [color]="!primary ? buttonColor.Secondary : buttonColor.Primary"
    [disabled]="!enabled"
    [displayType]="buttonDisplayType"
    [class.file-selector__browse-files-link]="buttonDisplayType === buttonDisplayTypes.Text"
    (click)="browseFiles($event)"
  >
    {{ label }}
  </button>
</ng-container>
